// 行为记录
// 参数说明   this  操作类型  操作模块  操作内容
import axios from "axios";
const request = axios.create({
  baseURL: "/apis", // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 150000, // request timeout
});
export async function HMCSMACHINECOLLECT({
  _this,
  action_id, //行为id
  action_type, // 动作类型
  target_id, //产品id
  target_name, //产品名字
  module = "自建商城", //
  page_info,
  previous_page,
  start_time,
  end_tme,
  page_info_url,
  previous_page_url,
  type,
  urlType,
}) {
  // type  1 是首页 2 是搜索页面  (1,2是i369项目)处理i369商城数据
  mallType(type);
  console.log("[  ] >", _this.$store.state);
  // 数据传参-------------------------------------------------
  let common = {
    user_id: _this.$store.state.username,
    log_type: "pc",
    browser_type: browserType(),
    cookie_id: _this.$cookie.get("uuid"),
    ip: _this.$store.state.loginIp,
  };
  let action = {
    action_id,
    action_type,
    target_id,
    target_name,
  };
  let page = {
    module, //369商城 || 自建商城
    page_info, //当前页面title
    previous_page, //上级页面title
    start_time, //进入页面时间戳
    end_tme, //离开页面时间戳
    page_info_url, //当前页url
    previous_page_url, //上一级界面url
  };
  let params = {
    common: common,
    action,
    page,
  };
  console.log(params);
  const res = await request({
    method: "POST",
    url: "/hmcsmachinecollect/v1/collect?SSOID=" + _this.$store.state.SSOID,
    data: params,
  })
    .then((res) => {
      if (res.data.success) {
        console.log("记录了");
      }
    })
    .catch((res) => {
      console.log(res.data);
    });
  function browserType() {
    let browser_type;
    const explorer = window.navigator.userAgent;
    if (explorer.indexOf("MSIE") >= 0) {
      browser_type = "IE"; //判断是否为IE浏览器
    } else if (explorer.indexOf("Firefox") >= 0) {
      browser_type = "Firefox"; //是否为Firefox浏览器
    } else if (explorer.indexOf("Chrome") >= 0) {
      browser_type = "Chrome"; //是否为Chrome浏览器
    } else if (explorer.indexOf("Opera") >= 0) {
      browser_type = "Opera"; //是否为Opera浏览器
    } else if (explorer.indexOf("Safari") >= 0) {
      browser_type = "Safari"; //是否为Safari浏览器
    }
    return browser_type;
  }
  function mallType(type) {
    //i369商城  根据type 来区分上一页地址
    switch (type) {
      case "1":
        previous_page_url = `https://${urlType}.i369.com`;
        previous_page = "i369首页";
        module = "369商城";
        break;
      case "2":
        previous_page_url = `http://${urlType}.i369.com/searchDetail`;
        previous_page = "i369搜索列表页";
        module = "369商城";
        break;
      default:
    }
  }
}
